import { ProductTagCreatePage } from '@/features/product-tag/pages/ProductTagCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/product-tag/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_tag.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductTagCreatePage,
})
